// removed by extract-text-webpack-plugin
module.exports = {"container":"_6e46ae19e9_src-comparableSales-_Tab_container","active":"_55a1cae1b5_src-comparableSales-_Tab_active","frozen":"a55e69e873_src-comparableSales-_Tab_frozen","disabled":"_4e441f17a1_src-comparableSales-_Tab_disabled","name":"_410509e3c2_src-comparableSales-_Tab_name","menuTrigger":"_2704bb4509_src-comparableSales-_Tab_menuTrigger","menuContainer":"dd2abb89bb_src-comparableSales-_Tab_menuContainer","item":"_93e08326ef_src-comparableSales-_Tab_item","areYouSureBox":"_0859321716_src-comparableSales-_Tab_areYouSureBox"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/Tab.css
// module id = 1042
// module chunks = 0